import type { StackProps } from '@montugroup/design-system';
import { Stack, Typography } from '@montugroup/design-system';
import { Grid2, useTheme } from '@mui/material';
import type { StepContent } from './StepsCarousel';
import {
  StyledAllStepsStack,
  StyledBoxWithTransition,
  StyledHeadingBoxDesktop,
  StyledNumberCircle,
  StyledNumberGrid,
  StyledStepGrid,
} from './StepsCarouselStyles';

type StepsCarouselStepsProps = {
  title: React.ReactNode;
  subtitle: string;
  steps: StepContent[];
  activeStep: number;
  onStepClick: (stepIndex: number) => void;
};

export type StyledStepStackProps = StackProps & {
  activeStep: boolean;
};

export function StepsCarouselSteps({ title, subtitle, steps, activeStep, onStepClick }: StepsCarouselStepsProps) {
  const theme = useTheme();
  return (
    <Stack alignItems="flex-start" spacing={10}>
      <StyledHeadingBoxDesktop>
        <Typography variant="h4" fontSize={30} fontWeight={600}>
          {title}
        </Typography>
        <Typography variant="subtitle1">{subtitle}</Typography>
      </StyledHeadingBoxDesktop>
      <StyledAllStepsStack spacing={9}>
        {steps.map((step, index) => (
          <StyledStepGrid
            container
            key={`step${step.stepNumber}`}
            activeStep={activeStep === index}
            onClick={() => onStepClick(index)}
            spacing={4}
            alignItems="center"
          >
            <StyledNumberGrid
              container
              item
              justifyContent="center"
              alignItems="center"
              minWidth={theme.spacing(7.5)}
              width={theme.spacing(7.5)}
              height={theme.spacing(7.5)}
            >
              <StyledNumberCircle />
              <Typography variant={'body2'}>{step.stepNumber}</Typography>
            </StyledNumberGrid>
            <Grid2 sx={{ paddingTop: '0 !important' }}>
              <StyledBoxWithTransition paddingLeft={0}>
                <Typography
                  variant={'body2'}
                  sx={(theme) => ({ color: activeStep === index ? '' : theme.palette.text.secondary })}
                >
                  {step.stepText}
                </Typography>
              </StyledBoxWithTransition>
            </Grid2>
          </StyledStepGrid>
        ))}
      </StyledAllStepsStack>
    </Stack>
  );
}
